/* Country/currency data derived from Unicode CLDR.
UNICODE LICENSE V3

COPYRIGHT AND PERMISSION NOTICE

Copyright © 1991-2026 Unicode, Inc.

NOTICE TO USER: Carefully read the following legal agreement. BY
DOWNLOADING, INSTALLING, COPYING OR OTHERWISE USING DATA FILES, AND/OR
SOFTWARE, YOU UNEQUIVOCALLY ACCEPT, AND AGREE TO BE BOUND BY, ALL OF THE
TERMS AND CONDITIONS OF THIS AGREEMENT. IF YOU DO NOT AGREE, DO NOT
DOWNLOAD, INSTALL, COPY, DISTRIBUTE OR USE THE DATA FILES OR SOFTWARE.

Permission is hereby granted, free of charge, to any person obtaining a
copy of data files and any associated documentation (the "Data Files") or
software and any associated documentation (the "Software") to deal in the
Data Files or Software without restriction, including without limitation
the rights to use, copy, modify, merge, publish, distribute, and/or sell
copies of the Data Files or Software, and to permit persons to whom the
Data Files or Software are furnished to do so, provided that either (a)
this copyright and permission notice appear with all copies of the Data
Files or Software, or (b) this copyright and permission notice appear in
associated Documentation.

THE DATA FILES AND SOFTWARE ARE PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF
THIRD PARTY RIGHTS.

IN NO EVENT SHALL THE COPYRIGHT HOLDER OR HOLDERS INCLUDED IN THIS NOTICE
BE LIABLE FOR ANY CLAIM, OR ANY SPECIAL INDIRECT OR CONSEQUENTIAL DAMAGES,
OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS,
WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION,
ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THE DATA
FILES OR SOFTWARE.

Except as contained in this notice, the name of a copyright holder shall
not be used in advertising or otherwise to promote the sale, use or other
dealings in these Data Files or Software without prior written
authorization of the copyright holder.

*/
(() => {
  'use strict';
  if (window.__nmrLocalization) return;
  const picker = document.querySelector('[data-market-picker]');
  const configElement = document.getElementById('nmr-localization-config');
  if (!picker || !configElement) return;
  window.__nmrLocalization = true;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const form = picker.querySelector('form');
  const select = picker.querySelector('[name="country_code"]');
  const label = picker.querySelector('[data-market-label]');
  const summary = picker.querySelector('summary');
  const flag = picker.querySelector('.nmr-market-flag');
  const note = picker.querySelector('[data-market-note]');
  const status = document.querySelector('[data-market-estimate-status]');
  if (!form || !select || !label || !summary || !flag || !note || !status) return;
  const currencies = {"AC":"SHP","AD":"EUR","AE":"AED","AF":"AFN","AG":"XCD","AI":"XCD","AL":"ALL","AM":"AMD","AO":"AOA","AR":"ARS","AS":"USD","AT":"EUR","AU":"AUD","AW":"AWG","AX":"EUR","AZ":"AZN","BA":"BAM","BB":"BBD","BD":"BDT","BE":"EUR","BF":"XOF","BG":"EUR","BH":"BHD","BI":"BIF","BJ":"XOF","BL":"EUR","BM":"BMD","BN":"BND","BO":"BOB","BQ":"USD","BR":"BRL","BS":"BSD","BT":"BTN","BV":"NOK","BW":"BWP","BY":"BYN","BZ":"BZD","CA":"CAD","CC":"AUD","CD":"CDF","CF":"XAF","CG":"XAF","CH":"CHF","CI":"XOF","CK":"NZD","CL":"CLP","CM":"XAF","CN":"CNY","CO":"COP","CR":"CRC","CU":"CUP","CV":"CVE","CW":"XCG","CX":"AUD","CY":"EUR","CZ":"CZK","DE":"EUR","DG":"USD","DJ":"DJF","DK":"DKK","DM":"XCD","DO":"DOP","DZ":"DZD","EA":"EUR","EC":"USD","EE":"EUR","EG":"EGP","EH":"MAD","ER":"ERN","ES":"EUR","ET":"ETB","EU":"EUR","FI":"EUR","FJ":"FJD","FK":"FKP","FM":"USD","FO":"DKK","FR":"EUR","GA":"XAF","GB":"GBP","GD":"XCD","GE":"GEL","GF":"EUR","GG":"GBP","GH":"GHS","GI":"GIP","GL":"DKK","GM":"GMD","GN":"GNF","GP":"EUR","GQ":"XAF","GR":"EUR","GS":"GBP","GT":"GTQ","GU":"USD","GW":"XOF","GY":"GYD","HK":"HKD","HM":"AUD","HN":"HNL","HR":"EUR","HT":"HTG","HU":"HUF","IC":"EUR","ID":"IDR","IE":"EUR","IL":"ILS","IM":"GBP","IN":"INR","IO":"USD","IQ":"IQD","IR":"IRR","IS":"ISK","IT":"EUR","JE":"GBP","JM":"JMD","JO":"JOD","JP":"JPY","KE":"KES","KG":"KGS","KH":"KHR","KI":"AUD","KM":"KMF","KN":"XCD","KP":"KPW","KR":"KRW","KW":"KWD","KY":"KYD","KZ":"KZT","LA":"LAK","LB":"LBP","LC":"XCD","LI":"CHF","LK":"LKR","LR":"LRD","LS":"ZAR","LT":"EUR","LU":"EUR","LV":"EUR","LY":"LYD","MA":"MAD","MC":"EUR","MD":"MDL","ME":"EUR","MF":"EUR","MG":"MGA","MH":"USD","MK":"MKD","ML":"XOF","MM":"MMK","MN":"MNT","MO":"MOP","MP":"USD","MQ":"EUR","MR":"MRU","MS":"XCD","MT":"EUR","MU":"MUR","MV":"MVR","MW":"MWK","MX":"MXN","MY":"MYR","MZ":"MZN","NA":"NAD","NC":"XPF","NE":"XOF","NF":"AUD","NG":"NGN","NI":"NIO","NL":"EUR","NO":"NOK","NP":"NPR","NR":"AUD","NU":"NZD","NZ":"NZD","OM":"OMR","PA":"PAB","PE":"PEN","PF":"XPF","PG":"PGK","PH":"PHP","PK":"PKR","PL":"PLN","PM":"EUR","PN":"NZD","PR":"USD","PS":"ILS","PT":"EUR","PW":"USD","PY":"PYG","QA":"QAR","RE":"EUR","RO":"RON","RS":"RSD","RU":"RUB","RW":"RWF","SA":"SAR","SB":"SBD","SC":"SCR","SD":"SDG","SE":"SEK","SG":"SGD","SH":"SHP","SI":"EUR","SJ":"NOK","SK":"EUR","SL":"SLE","SM":"EUR","SN":"XOF","SO":"SOS","SR":"SRD","SS":"SSP","ST":"STN","SV":"USD","SX":"XCG","SY":"SYP","SZ":"SZL","TA":"GBP","TC":"USD","TD":"XAF","TF":"EUR","TG":"XOF","TH":"THB","TJ":"TJS","TK":"NZD","TL":"USD","TM":"TMT","TN":"TND","TO":"TOP","TR":"TRY","TT":"TTD","TV":"AUD","TW":"TWD","TZ":"TZS","UA":"UAH","UG":"UGX","UM":"USD","US":"USD","UY":"UYU","UZ":"UZS","VA":"EUR","VC":"XCD","VE":"VES","VG":"USD","VI":"USD","VN":"VND","VU":"VUV","WF":"XPF","WS":"WST","XK":"EUR","YE":"YER","YT":"EUR","ZA":"ZAR","ZM":"ZMW","ZW":"ZWG"};
  const validCountry = (value) => typeof value === 'string' && /^[A-Z]{2}$/.test(value) && value !== 'ZZ';
  const validCurrency = (value) => typeof value === 'string' && /^[A-Z]{3}$/.test(value);
  if (!validCountry(config.country) || !validCurrency(config.currency)) return;
  const sessionGet = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const sessionSet = (key,value) => { try { sessionStorage.setItem(key,value); } catch {} };
  const sessionRemove = (key) => { try { sessionStorage.removeItem(key); } catch {} };
  const preferencesAllowed = () => {
    try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; } catch { return false; }
  };
  const preferenceGet = () => {
    if (!preferencesAllowed()) return null;
    try {
      const value = JSON.parse(localStorage.getItem('nmr-market-preference'));
      return validCountry(value?.country) && Date.now() - value.updated < 30 * 86400000 ? value.country : null;
    } catch { return null; }
  };
  let url = new URL(location.href);
  let marker = url.searchParams.get('_nmr_region');
  if (marker) {
    url.searchParams.delete('_nmr_region');
    history.replaceState(history.state,'',url.pathname + url.search + url.hash);
    if (marker === 'manual') sessionSet('nmr-market-manual',config.country);
    else if (validCountry(marker)) sessionSet('nmr-market-attempt-' + marker,'1');
  }
  let manual = marker === 'manual' || !!sessionGet('nmr-market-manual') || !!preferenceGet();
  let automatic = false;
  let generation = 0;
  let activeConversion = null;
  let observer;
  let ratePromise;
  const originalPrices = new WeakMap();
  const supported = new Set(Array.from(select.options).map(option => option.value));
  const currentName = select.selectedOptions[0]?.textContent.split(' · ')[0] || config.country;
  const substitute = (text) => String(text || '').replaceAll('[currency]',config.currency);
  function setReturnMarker(value) {
    const target = new URL(location.href);
    target.searchParams.set('_nmr_region',value);
    let input = form.querySelector('[name="return_to"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.append(input); }
    input.value = target.pathname + target.search + target.hash;
  }
  function rememberManual() {
    manual = true;
    generation++;
    resetConversion();
    nativeDisplay();
    sessionSet('nmr-market-manual',select.value);
    if (preferencesAllowed()) {
      try { localStorage.setItem('nmr-market-preference',JSON.stringify({country:select.value,updated:Date.now()})); } catch {}
    }
    setReturnMarker('manual');
  }
  form.addEventListener('submit',() => { if (!automatic) rememberManual(); });
  select.addEventListener('change',() => { rememberManual(); form.requestSubmit(); });
  function showRegion(country,name,currency) {
    summary.removeAttribute('aria-busy');
    flag.hidden = false;
    label.textContent = name + ' · ' + currency;
    summary.setAttribute('aria-label',config.choose + ': ' + name + ' · ' + currency);
    flag.removeAttribute('srcset');
    flag.src = 'https://cdn.shopify.com/static/images/flags/' + country.toLowerCase() + '.svg?width=32';
    picker.dataset.displayCountry = country;
    picker.dataset.displayCurrency = currency;
  }
  function nativeDisplay() {
    showRegion(config.country,currentName,config.currency);
    note.textContent = config.nativeNote;
    status.hidden = true;
  }
  async function fetchJSON(url,options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(),4500);
    try {
      const response = await fetch(url,{...options,signal:controller.signal});
      if (!response.ok) throw new Error('Unavailable');
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  function getRates() {
    if (!ratePromise) ratePromise = (async () => {
      const base = config.currency.toLowerCase();
      for (const host of ['https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest','https://latest.currency-api.pages.dev']) {
        try {
          const data = await fetchJSON(host + '/v1/currencies/' + base + '.min.json',{credentials:'omit',referrerPolicy:'no-referrer',cache:'default'});
          const age = Date.now() - Date.parse(data.date + 'T00:00:00Z');
          if (!Number.isFinite(age) || age < -86400000 || age > 7 * 86400000 || !data[base]) throw new Error('Stale rates');
          return data[base];
        } catch {}
      }
      return null;
    })();
    return ratePromise;
  }
  function convertPrice(element) {
    if (!activeConversion || element.dataset.currency !== config.currency) return;
    const amount = Number(element.dataset.amount);
    if (!element.hasAttribute('data-amount') || !Number.isFinite(amount)) return;
    if (!originalPrices.has(element)) originalPrices.set(element,element.textContent);
    const text = '≈ ' + activeConversion.format.format(amount / 100 * activeConversion.rate);
    if (element.textContent !== text) element.textContent = text;
    const original = originalPrices.get(element);
    element.title = original.includes(config.currency) ? original : original + ' ' + config.currency;
    element.dataset.nmrEstimated = 'true';
  }
  function convertWithin(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('[data-nmr-money]')) convertPrice(root);
    root.querySelectorAll('[data-nmr-money]').forEach(convertPrice);
    const notes = [...root.querySelectorAll('[data-local-currency-note]')];
    if (root.matches?.('[data-local-currency-note]')) notes.push(root);
    for (const element of notes) {
      element.textContent = substitute(config.estimateStatus);
      element.hidden = false;
    }
  }
  function startConversion(rate,currency) {
    activeConversion = {rate,format:new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency})};
    convertWithin(document);
    if (!observer) {
      observer = new MutationObserver(records => {
        for (const record of records) for (const node of record.addedNodes) convertWithin(node);
      });
      observer.observe(document.body,{childList:true,subtree:true});
    }
  }
  function resetConversion() {
    activeConversion = null;
    observer?.disconnect();
    observer = null;
    document.querySelectorAll('[data-nmr-estimated]').forEach(element => {
      if (originalPrices.has(element)) element.textContent = originalPrices.get(element);
      element.removeAttribute('data-nmr-estimated');
      element.removeAttribute('title');
    });
    document.querySelectorAll('[data-local-currency-note]').forEach(element => { element.hidden = true; });
  }
  async function detect() {
    const run = ++generation;
    if (config.designMode) { nativeDisplay(); return; }
    summary.setAttribute('aria-busy','true');
    flag.hidden = true;
    label.textContent = config.detecting || currentName;
    try {
      const root = new URL(config.root || '/',location.origin);
      if (root.origin !== location.origin) return;
      const endpoint = new URL(root.pathname.replace(/\/?$/,'/') + 'browsing_context_suggestions.json',location.origin);
      endpoint.searchParams.set('country[enabled]','true');
      endpoint.searchParams.set('language[enabled]','false');
      const data = await fetchJSON(endpoint.href,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (run !== generation || manual) return;
      const detected = data.detected_values?.country;
      const country = detected?.handle;
      if (!validCountry(country)) return;
      const name = typeof detected.name === 'string' && detected.name.length < 100 ? detected.name : country;
      picker.dataset.detectedCountry = country;
      if (supported.has(country) && country !== config.country && marker !== country && !sessionGet('nmr-market-attempt-' + country)) {
        sessionSet('nmr-market-attempt-' + country,'1');
        setReturnMarker(country);
        select.value = country;
        automatic = true;
        form.requestSubmit();
        return;
      }
      const currency = currencies[country];
      showRegion(country,name,config.currency);
      if (!validCurrency(currency) || currency === config.currency) return;
      const rates = await getRates();
      if (run !== generation || manual) return;
      const rate = rates?.[currency.toLowerCase()];
      if (!Number.isFinite(rate) || rate <= 0) {
        status.textContent = substitute(config.unavailable);
        status.hidden = false;
        return;
      }
      startConversion(rate,currency);
      showRegion(country,name,currency + ' ≈');
      note.textContent = substitute(config.estimateNote);
      status.textContent = substitute(config.estimateStatus);
      status.hidden = false;
    } catch {} finally {
      if (run === generation && summary.getAttribute('aria-busy') === 'true' && !automatic) nativeDisplay();
    }
  }
  picker.querySelector('[data-use-location]')?.addEventListener('click',() => {
    sessionRemove('nmr-market-manual');
    if (preferencesAllowed()) { try { localStorage.removeItem('nmr-market-preference'); } catch {} }
    const detected = picker.dataset.detectedCountry;
    if (validCountry(detected)) sessionRemove('nmr-market-attempt-' + detected);
    manual = false;
    automatic = false;
    marker = null;
    ratePromise = null;
    resetConversion();
    detect();
  });
  nativeDisplay();
  if (!manual) detect();
})();
